import BaseComponent from 'scripts/BaseComponent.js';

export default class NavigationMenu extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {};

    this.dom = {
      $component: component,
    };

    this.state = {};

    this.mount();
  }

  mount() {
    super.mount();
  }
}
